import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  status: "idle",
  selectedSymbol: "BTCUSDT",
  selectedSegment: "crypto",
  buyCommission: 0,
  sellCommission: 0,
  commissionType: "Flat",
};

const watchlistSlice = createSlice({
  name: "watchlist",
  initialState,
  reducers: {
    setWatchlist(state, action) {
      // action.payload = [{ symbol, instrument_id }]
      state.items = action.payload;
      state.status = "success";
    },

    addToWatchlist(state, action) {
      // action.payload = { symbol, instrument_id }
      const exists = state.items.some(
        (item) => item.symbol === action.payload.symbol
      );
      if (!exists) {
        state.items.push(action.payload);
      }
    },

    removeFromWatchlist(state, action) {
      // action.payload = symbol string
      const symbol = action.payload;
      state.items = state.items.filter((item) => item.symbol !== symbol);
    },

    setLoading(state) {
      state.status = "loading";
    },

    setError(state) {
      state.status = "error";
    },
    setSelectedSymbol(state, action) {
      const { symbol, segment, buyCommission, sellCommission, commissionType } =
        action.payload;
      state.selectedSymbol = symbol;
      state.selectedSegment = segment;
      state.buyCommission = buyCommission;
      state.sellCommission = sellCommission;
      state.commissionType = commissionType;
    },
  },
});

export const {
  setWatchlist,
  addToWatchlist,
  removeFromWatchlist,
  setLoading,
  setError,
  setSelectedSymbol,
} = watchlistSlice.actions;

export default watchlistSlice.reducer;
